import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import booksAPI from '../../sources/api/booksAPI';

// constants
import { BOOKS_FETCH_CATERERS } from '../../constants/booksTypes';

// lib
import httpSaga from '../../lib/httpSaga';

export function* booksFetchCaterers(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(BOOKS_FETCH_CATERERS, call(booksAPI.fetchCaterers, params));
  } catch (e) {
    yield put(error(BOOKS_FETCH_CATERERS, e));
  } finally {
    yield put(doneIndicator(BOOKS_FETCH_CATERERS));
  }
}

export function* watchBooksFetchCaterers() {
  yield takeEvery(BOOKS_FETCH_CATERERS, booksFetchCaterers);
}

export default function* root() {
  yield all([
    fork(watchBooksFetchCaterers)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/books/booksFetchCaterers.js